import { HTTP } from '@/CallAPI'
export default {
  getUser (page = 1, per_page = 20, search = '', sort = 'desc', status = '', organization_id = '', group_id = '') {
    return HTTP.get('/users', {
      params: { page, per_page, search, sort, status, organization_id, group_id }
    })
  },

  createUser (user) {
    return HTTP.post('/users', user)
  },

  showUser (user) {
    return HTTP.get('/users/' + user.id)
  },

  updateUser (user) {
    return HTTP.post('/users/' + user.get('id'), user)
  },

  destroyUser (user) {
    return HTTP.delete('/users/' + user.id)
  },

  getTrashUser (page = 1, per_page = 20) {
    return HTTP.get('/users/trashs', {
      params: { page, per_page }
    })
  },

  restore (data) {
    return HTTP.post('/users/trashs', {data}
    )
  },

  activeUser (user) {
    return HTTP.post('users/' + user.id + '/active')
  },

  deactivateUser (user) {
    return HTTP.post('users/' + user.id + '/deactivate')
  },

  chat (user, body) {
    return HTTP.post('chats/' + user.id, body)
  },

  chatSystem (text) {
    return HTTP.post('http://localhost:3000/api/chat', {text})
  },

  getUserOnline () {
    return HTTP.get('users/active')
  }
}



// WEBPACK FOOTER //
// ./src/service/user.js